exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".page-birthday .birthday-info {\n  font-size: 16px;\n  text-align: center;\n  color: #727272;\n  line-height: 1.5;\n  padding-top: 24px; }\n\n.page-birthday > button {\n  margin-top: 20px; }\n\n.page-birthday .birthday-input {\n  margin: 8px 0;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: distribute;\n  justify-content: space-around;\n  -ms-flex-align: center;\n  align-items: center; }\n  .page-birthday .birthday-input > * {\n    width: 100%;\n    margin: 0 4px; }\n  .page-birthday .birthday-input .separator {\n    width: 24px;\n    margin: 0;\n    text-align: center;\n    color: #3f4361;\n    opacity: 0.4;\n    font-size: 22px; }\n  .page-birthday .birthday-input input {\n    line-height: 64px;\n    text-align: center; }\n\n.page-birthday .error-text {\n  color: #e05139;\n  line-height: 16px;\n  font-size: 13px;\n  margin-bottom: 8px;\n  height: 16px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/pages/Birthday/styles.scss
// module id = 1297
// module chunks = 0